import { TrendingUp, TrendingDown, DollarSign, Users } from 'lucide-react';

const Dashboard = () => {
  // Dummy data
  const stats = [
    {
      name: 'Total Revenue',
      value: '$2.4M',
      change: '+12.5%',
      trend: 'up',
      icon: DollarSign,
    },
    {
      name: 'Operating Expenses',
      value: '$1.8M',
      change: '+5.2%',
      trend: 'up',
      icon: TrendingUp,
    },
    {
      name: 'Net Income',
      value: '$600K',
      change: '+18.7%',
      trend: 'up',
      icon: TrendingUp,
    },
    {
      name: 'Team Members',
      value: '42',
      change: '+3',
      trend: 'up',
      icon: Users,
    },
  ];

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-neutral-900">Dashboard</h1>
        <p className="text-neutral-600 mt-1">
          Welcome back! Here's your financial overview.
        </p>
      </div>

      {/* Stats grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {stats.map((stat) => (
          <div key={stat.name} className="card">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center">
                <stat.icon className="w-6 h-6 text-primary-600" />
              </div>
              <span
                className={`text-sm font-medium ${
                  stat.trend === 'up' ? 'text-success-600' : 'text-alert-600'
                }`}
              >
                {stat.change}
              </span>
            </div>
            <h3 className="text-2xl font-bold text-neutral-900">{stat.value}</h3>
            <p className="text-sm text-neutral-600 mt-1">{stat.name}</p>
          </div>
        ))}
      </div>

      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="card">
          <h3 className="text-lg font-semibold mb-4">Revenue Trend</h3>
          <div className="h-64 flex items-center justify-center bg-neutral-50 rounded-lg">
            <p className="text-neutral-500">Chart placeholder</p>
          </div>
        </div>

        <div className="card">
          <h3 className="text-lg font-semibold mb-4">Expense Breakdown</h3>
          <div className="h-64 flex items-center justify-center bg-neutral-50 rounded-lg">
            <p className="text-neutral-500">Chart placeholder</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
